import adminCatalogoService from '../../services/admin/AdminCatalogoService'

/**
 * Estado da listagem /admin/catalogos (#52). O detalhe não passa por aqui: é
 * uma tela de um registro só, e a view guarda o que carregou.
 */
const initialState = () => ({
  catalogos: [],
  pagination: {
    total: 0,
    current_page: 1,
    per_page: 15,
    last_page: 1,
  },
  valoresIndisponiveis: false,
  resumo: null,
  operadores: [],
  loading: false,
  loadingResumo: false,
})

/**
 * Sequência das requisições em voo, no molde do AdminDashboardStore: filtro
 * trocado rápido deixa mais de uma consulta pendente, e a mais antiga não
 * pode sobrescrever a resposta da mais recente. Dois contadores porque lista e
 * resumo viajam separados e chegam fora de ordem.
 */
let requestId = 0
let resumoRequestId = 0

export const adminCatalogoModule = {
  namespaced: true,

  state: initialState(),

  mutations: {
    SET_CATALOGOS(state, payload) {
      state.catalogos = Object.freeze(payload?.data || [])
      state.valoresIndisponiveis = !!payload?.valores_indisponiveis
      state.pagination = {
        total: payload?.total || 0,
        current_page: payload?.current_page || 1,
        per_page: payload?.per_page || 15,
        last_page: payload?.last_page || 1,
      }
    },
    SET_RESUMO(state, resumo) {
      state.resumo = resumo || null
    },
    SET_OPERADORES(state, operadores) {
      state.operadores = operadores || []
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_LOADING_RESUMO(state, loading) {
      state.loadingResumo = loading
    },
    RESET(state) {
      Object.assign(state, initialState())
    },
  },

  actions: {
    async fetchCatalogos({ commit }, params = {}) {
      const current = ++requestId
      commit('SET_LOADING', true)

      try {
        const data = await adminCatalogoService.getCatalogos(params)

        if (current !== requestId) return data

        commit('SET_CATALOGOS', data)
        return data
      } finally {
        if (current === requestId) commit('SET_LOADING', false)
      }
    },

    async fetchResumo({ commit }, params = {}) {
      const current = ++resumoRequestId
      commit('SET_LOADING_RESUMO', true)

      try {
        const data = await adminCatalogoService.getResumo(params)

        if (current !== resumoRequestId) return data

        commit('SET_RESUMO', data?.data)
        return data
      } finally {
        if (current === resumoRequestId) commit('SET_LOADING_RESUMO', false)
      }
    },

    async fetchFiltros({ commit }) {
      const data = await adminCatalogoService.getFiltros()
      commit('SET_OPERADORES', data?.operadores)
      return data
    },

    async fetchCatalogo(_, hashid) {
      return await adminCatalogoService.getCatalogo(hashid)
    },

    async fetchCarrinho(_, hashid) {
      return await adminCatalogoService.getCarrinho(hashid)
    },

    async fetchVisitas(_, hashid) {
      return await adminCatalogoService.getVisitas(hashid)
    },

    async fetchHistorico(_, hashid) {
      return await adminCatalogoService.getHistorico(hashid)
    },

    async renewCatalogo(_, { hashid, payload }) {
      return await adminCatalogoService.renew(hashid, payload)
    },

    async toggleValid(_, hashid) {
      return await adminCatalogoService.toggleValid(hashid)
    },

    async resendEmail(_, { hashid, id }) {
      return await adminCatalogoService.resendEmail(hashid, id)
    },

    resetCatalogos({ commit }) {
      // Invalida o que estiver em voo: sair da tela não pode repovoar o
      // módulo depois do RESET.
      requestId++
      resumoRequestId++
      commit('RESET')
    },
  },

  getters: {
    catalogos: (state) => state.catalogos,
    pagination: (state) => state.pagination,
    valoresIndisponiveis: (state) => state.valoresIndisponiveis,
    resumo: (state) => state.resumo,
    operadores: (state) => state.operadores,
    loading: (state) => state.loading,
    loadingResumo: (state) => state.loadingResumo,
  },
}
